
import { InfomindsColors } from '@infominds/react-native-components'

export const Colors = {
    tint: InfomindsColors.main,
    listItem: InfomindsColors.dark,
    icon: '#7C7C7D',
    error: InfomindsColors.red,
    info: InfomindsColors.yellow,
    light: {
        text: InfomindsColors.text,
        textDetail: InfomindsColors.textDetail,
        textPlaceholder: '#6D776E',
        background: '#fff',
        backgroundModal: '#fff',
        inputBackground: '#F6F6F6',
        inputBorder: '#E8E8E8',
        card: '#fff'
    },
    dark: {
        text: '#fff',
        textDetail: InfomindsColors.textDetail,
        textPlaceholder: '#999999',
        background: '#000',
        backgroundModal: '#0E0E0E',
        inputBackground: '#1C1D1F',
        inputBorder: InfomindsColors.dark,
        card: '#1C1D1F'
    },
    red: InfomindsColors.red,
    yellow: InfomindsColors.yellow,
    black: InfomindsColors.dark,
    neutral: InfomindsColors.darker
}